/** Extended ERP fields merged into SKU form state (sent with WMS payload). */
export function getErpExtensionDefaults() {
  return {
    shortDescription: "",
    barcode: "",
    alternateSkuCode: "",
    itemStatus: "Draft",
    itemType: "",
    categoryCode: "",
    subCategoryCode: "",
    subBrand: "",
    variantType: "",
    variantCode: "",
    tenantId: "",
    organizationId: "",
    merchantHierarchyId: "",
    styleNumber: "",
    designReference: "",
    colorCode: "",
    sizeGroup: "",
    material: "",
    finish: "",
    productLine: "",
    launchDate: "",
    discontinueDate: "",
    hsnTaxCode: "",
    salesUom: "",
    pricingUom: "",
    purchaseUom: "",
    inventoryUom: "",
    pieceUom: "",
    baseUom: "",
    innerPackUom: "",
    outerPackUom: "",
    palletUom: "",
    piecesPerInnerPack: "",
    innerPacksPerOuterPack: "",
    piecesPerOuterPack: "",
    outerPacksPerPallet: "",
    catchWeightFlag: false,
    inboundCatchData: false,
    inboundSerialNo: "",
    inboundImei: "",
    inboundOther3: "",
    inboundOther4: "",
    inboundOther5: "",
    outboundCatchData: false,
    outboundSerialNo: "",
    outboundImei: "",
    outboundOther3: "",
    outboundOther4: "",
    outboundOther5: "",
    voiceGroupingId: "",
    uomConversionAllowed: true,
    decimalAllowed: false,
    minOrderQty: "",
    maxOrderQty: "",
    minReceiptQty: "",
    packConfigVersion: "",
    warehouseStorageType: "",
    putawayStrategy: "",
    pickStrategy: "",
    batchControlled: false,
    expiryControlled: false,
    reorderSafetyFlag: false,
    shelfLifeDays: "",
    fragileFlag: false,
    qcRequired: false,
    qcType: "",
    inspectionTemplateId: "",
    defaultWarehouse: "",
    storageTemperatureRange: "",
    stackLimit: "",
    weightPerUnit: "",
    volume: "",
    lengthDim: "",
    widthDim: "",
    heightDim: "",
    qcCertificateType: "",
    returnableFlag: true,
    countryOfOrigin: "",
    damageTolerance: "",
    overReceiptTolerance: "",
    underReceiptTolerance: "",
    packagingVarianceTolerance: "",
    remarks: "",
    createdOn: "",
    updatedBy: "",
    updatedOn: "",
    approvedBy: "",
    approvedOn: "",
    versionNumber: "",
    skuCodeUnique: true,
    barcodeUnique: true,
  };
}

export const ITEM_STATUS_OPTIONS = ["Draft", "Active", "Inactive", "Blocked"];
export const ITEM_TYPES = ["Finished Good", "Raw Material", "WIP", "Spare", "Service", "Bundle"];
export const CATEGORY_TREE = [
  {
    code: "APP",
    name: "Apparel",
    subcategories: [
      { code: "TOP", name: "Tops" },
      { code: "BTM", name: "Bottoms" },
    ],
  },
  {
    code: "HOM",
    name: "Home",
    subcategories: [
      { code: "DEC", name: "Decor" },
      { code: "KIT", name: "Kitchen" },
    ],
  },
];

export const ORGANIZATION_OPTIONS = ["ORG-001 HQ", "ORG-002 Regional", "ORG-003 DC East"];
